import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { FileService, FileInfoType, getFileExtension, getFileName, FileProcessingTypes } from '@schoolbelle/api/file';
import { LoadingService } from '@schoolbelle/common/loading';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-letter-filelist',
  templateUrl: './letter-filelist.component.html',
  styleUrls: ['./letter-filelist.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LetterFilelistComponent implements OnInit {

  @Input() list:FileInfoType[];
  @Input() open:boolean = false;

  realFileSize;
  constructor(
    private file:FileService,
    private loading:LoadingService,
    private toastr:ToastrService,
    // protected http: HttpClient,
  ) { }

  ngOnInit() {
    
  }

  download (item:FileInfoType) {
    const downloadableUrl = this.file.getDownloadableUrl(item);

    if (!downloadableUrl) {
      switch(item.processing) {
        case FileProcessingTypes.onGoing:
        case FileProcessingTypes.pending:
          return alert('죄송합니다. 해당파일은 변환이 진행중입니다. 변환이 완료된 후 다운로드할 수 있습니다.');
        case FileProcessingTypes.failed:
          return alert('죄송합니다. 해당파일은 변환이 실패했으며 다운로드받을 수 없습니다.');
        default:
          return alert('죄송합니다. 업로드가 실패한 파일로 보입니다.');
      }
    }  

    const filename = typeof item.processing === 'number' ? (getFileName(item.name) + '.' + (item.type.match('image') ? 'jpg' : getFileExtension(downloadableUrl))) : item.name;
    const subscription = of(downloadableUrl).pipe(
      switchMap((url)=>{
        return this.file.download(url, filename);
      })
    )  
    .subscribe(e=>{
      if (e instanceof HttpResponse) {
        
      } else {
        const perc = Math.round(e.loaded / e.total * 100);
        this.loading.update({message:`다운로드중입니다...${perc}%`});
      }
    });
    this.loading.open({message:'다운로드중입니다...', busy:subscription}); 
  }

  downloadAll() {
    const subscription = this.file.downloadAsZip(this.list)
      .subscribe(()=>{}, (error)=>{
        this.toastr.error('다운로드 중 오류가 발생했습니다.');
      });
    this.loading.open({message:'다운로드중입니다...', busy:subscription}); 
  }

  // need to refactoring for reducing N/W load
  // getImageSize(item) {
    // console.log(item.name, item.type.indexOf('image/'), item.type, item.size);
    // get size when item type is image
  //   if(item.type.indexOf('image/') >= 0) {
  //     const req = new HttpRequest('GET', item.url, { reportProgress: true, responseType: 'blob'});
    
  //     this.http.request(req).pipe(
  //       map(event=>{
  //         if (event instanceof HttpResponse) {
  //           return (<any>event.body).size;
  //         }
  //       })
  //     )
  //     .subscribe(e=>{
  //       if(e) this.realFileSize = e;
  //     });
  
  //     return this.realFileSize;
  //   } else {
  //     return item.size;
  //   }
  // }
}
